<template>
  <div class="minimum-order pop_sales popup_wrap" style="display:block">
    <div class="popup_in">
      <div class="popup">
        <div class="popup_close stay_close close-animate">
          <a href="javascript:void(0);" @click.prevent="closePop">
            <close/>
          </a>
        </div>
        <div class="pp_prod_bottom">
          <div v-if="!minimumReached">
            <h2 class="title25" style="margin-top:20px;">
              היי, חסרים לך <span class="open-amount">{{ openAmount }} {{ currencySumbol }}</span> בשביל להגיע למינימום הזמנה ({{ minimumOrderAmount }} {{ currencySumbol }})
            </h2>
            <div class="text center">אבל אין מה לדאוג, יש לנו עוד מלא מוצרים להציע לך</div>
            <div class="pp_slide_wrap small-arrows" :class="{'slide_2' : products.length == 2 }" v-if="products.length">
            <div class="arrow_r ease" style="display:none;">
              <a href="javascript:void(0);">
                <arrow-right/>
              </a>
            </div>
            <div class="arrow_l ease" style="display:none;">
              <a href="javascript:void(0);">
                <arrow-left/>
              </a>
            </div>
            <div class="pp_slide clearfix">
              <slick
                  ref="slick"
                  :options="slickOptions"
                  v-if="products && slickOptions.nextArrow && slickOptions.prevArrow"
              >
                <Product
                    v-bind:product="product"
                    v-bind:index="index"
                    v-bind:is_popup="true"
                    v-for="(product, index) in (products)"
                    :key="product.id"
                ></Product>
              </slick>
            </div>
          </div>
          </div>
          <div v-if="minimumReached">
            <h2 class="title25" style="margin-top:20px;">
              איזה כיף! הגעת למינימום, יאללה ממשיכים
            </h2>
          </div>
          <div class="bt_green ease">
            <a href="#" @click.prevent="redirectToShop">{{ buttonText }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import close from "../../assets/img/close.svg";
import LOGO from "../../assets/img/carmella.svg";
import arrowLeft from "../../assets/img/arrow_l.svg";
import arrowRight from "../../assets/img/arrow_r.svg";
import Product from "../Product/Product";
import Slick from "vue-slick";
import {mapActions, mapState} from "vuex";

export default {
  data() {
    return {
      currencySumbol: wpData.currencySumbol,
      minimumOrderAmount: parseFloat(wpData.minimum_order.amount).toFixed(2),
      openAmount: (parseFloat(wpData.minimum_order.amount) - this.$store.state.cartTotal).toFixed(2),
      products: this.getProducts(),
      slickOptions: {
        rtl: true,
        dots: false,
        infinite: true,
        arrows: true,
        centerMode: false,
        nextArrow: false,
        prevArrow: false,
        slidesToShow: wpData.minimum_order.products ? (wpData.minimum_order.products.length > 1 ? 2 : 1) : 1,
        slidesToScroll: wpData.minimum_order.products ? (wpData.minimum_order.products.length > 1 ? 2 : 1) : 1,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 800,
            // settings: "unslick"
            settings: {
              slidesToShow: 2,
              dots: true,
              arrows: false
            }
          }
        ]
      },
      minimumReached: false,
      buttonText: 'להמשך קנייה באתר'
    };
  },
  mounted() {
    this.slickOptions.nextArrow = $(".arrow_l");
    this.slickOptions.prevArrow = $(".arrow_r");
  },
  watch: {
    cartTotal(val) {
      this.openAmount = (parseFloat(wpData.minimum_order.amount) - val).toFixed(2);
      if (this.openAmount <= 0) {
        this.minimumReached = true;
        this.buttonText = 'להזמנה מאובטחת';
      }
    }
  },
  computed: {
    ...mapState(['permOrderNew']),
    cartTotal() {
      return this.$store.state.cartTotal;
    },
    isPermenent() {
      return this.$store.state.createPermenantOrder;
    },
    isPermenentEdit() {
      return !!(typeof this.$store.state.permenantOrderEdit == "object" && this.$store.state.permenantOrderEdit);

    }
  },
  methods: {
    //...mapActions(["getProductById", "updateCart", "clarCart"]),
    ...mapActions(["addToPermanent"]),
    closePop() {
      this.$modal.hide("minimum-order");
    },
    redirectToShop() {
      this.$modal.hide("minimum-order");
      if (this.minimumReached) {
        if (this.permOrderNew) {
          EventBus.$emit('permanentOrderNew');
          return;
        } else if (this.isPermenent || this.isPermenentEdit) {
          EventBus.$emit('permanentOrderSave');
          return;
        }
        this.$router.push("/checkout/");
      }
    },
    getProducts() {
      if (!wpData.minimum_order.products) {
        return false;
      }

      const added = this.$store.state.added.map(item => item['id']);

      let products = wpData.minimum_order.products.filter((product) => {
        return !added.includes(product.id);
      });

      const shuffled = products.sort(() => 0.5 - Math.random());
      products = shuffled.slice(0,10);

      // get related products from cart - not working becuse related products are removed from sub-category product list in php cache.php
      // solution is:
      // 1- to re-add related to category json (likely to create slowdowns)
      // 2- to do ajax requests to json file (likely to create slowdowns)
      // currently decided to use minimum order products related products

      // this.$store.state.added.map(item => {
      //   console.log(item);
      //   if (item.relatedProducts) {
      //     console.log('yay');
      //     item.relatedProducts.map(product => {
      //       console.log(product);
      //       products.push(product);
      //     })
      //   }
      // });

      return products;
    }
  },
  components: {
    LOGO,
    close,
    Slick,
    arrowLeft,
    arrowRight,
    Product
  }
};
</script>
<style>
.minimum-order .pr_plus_first svg {
  width: 45px !important;
}
.minimum-order .addto_cart_in svg {
  width: 22px !important;
}
@media (max-width: 767px) {
  .minimum-order ul.slick-dots {
    bottom: -38px;
  }
}
</style>
<style scoped>
@media (max-width: 767px) {
  .popup {
    top: 60px;
    margin: 0 10px;
    background: #efede9;
    border:0;
    padding: 15px 0 35px;
  }
  .bt_green a {
    margin-top: 3em;
  }
  .pp_prod_bottom h2.title25 {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
}
h2.title25 {
  margin-bottom: 10px;
}
.popup {
  max-width: 650px;
}
.bt_green a {
  width: 320px;
}
.pp_slide_wrap {
  margin: 20px 0;
}
span.open-amount {
  color: #ea4725;
  display: inline;
  font-weight: inherit;
}
</style>
